import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

interface Props {
  elOpacity: boolean;
}

const SliderListContainer = styled.div<Props>`
  border-radius: ${36 * Screen.widthRatio}px;
  height: ${438 * Screen.widthRatio}px;
  margin-bottom: ${144 * Screen.widthRatio}px;
  margin-left: ${96 * Screen.widthRatio}px;
  min-width: ${1824 * Screen.widthRatio}px;
  opacity: ${(props) => (props.elOpacity ? 1 : 0)};
  overflow: hidden;
  position: relative;
  top: ${92 * Screen.widthRatio}px;
  width: max-content;
`;

export default withAnimation(SliderListContainer);
